<!-- ADD-MODAL-STRUCTURE -->
<div class="master-modal success_popup" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <!-- Modal-Header -->
        <!-- <div class="modal_close_btn">
          <span (click)="dialogClose()" class="modal-close"><i class="material-icons">close</i></span>
        </div> -->
        <!-- Modal content-->
        <div mat-dialog-content>
          <!-- Modal-Body -->
          <div class="modal-body br-8">
            <div class="modal_close_btn">
              <span (click)="dialogClose()" class="modal-close"><i class="material-icons">close</i></span>
            </div>
            <div class="success_details">
              <div class="status_img">
                <img src="../../../../../assets/images/payment-success.svg" alt="" loading="eager">
              </div>
              <div class="status_content">
                <h4>Email Verification Failed</h4>
                <!-- <p>By Clicking Continue</p>
                <p>Proceed for Completing Subscription</p> -->
                <!-- <div fxLayout="column" fxLayoutAlign="center center">
                  <button class="btn btn-sm global-btn" mat-button [routerLink]="['']"
                    (click)="tabMove()">Continue</button>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  